import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Play, Shield, Truck, BadgeCheck } from "lucide-react";
import { motion } from "framer-motion";
import logo from "@/assets/logo.png";
 
 
 const trustBadges = [
   { icon: Shield, label: "Industry Compliant" },
   { icon: Truck, label: "Quick Ship" },
   { icon: BadgeCheck, label: "Quality Guaranteed" },
 ];
 
 export function Hero() {
   return (
     <section className="relative overflow-hidden bg-gradient-hero">
       {/* Background pattern */}
       <div className="absolute inset-0 opacity-5">
         <div className="absolute inset-0" style={{
           backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
         }} />
       </div>
 
       <div className="container relative">
         <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 py-16 md:py-24 lg:py-32">
           {/* Content */}
           <motion.div 
             className="flex flex-col justify-center"
             initial={{ opacity: 0, y: 20 }}
             animate={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.6 }}
           >
             {/* Trust badges */}
             <div className="flex flex-wrap gap-3 mb-6">
               {trustBadges.map((badge) => (
                 <div 
                   key={badge.label}
                   className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent/10 text-accent text-xs font-medium"
                 >
                   <badge.icon className="h-3.5 w-3.5" />
                   {badge.label}
                 </div>
               ))}
             </div>
 
             <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground leading-tight mb-6">
               Your Nationwide
               <span className="block text-accent">Warehouse Racking</span>
               Brokerage Partner
             </h1>
 
             <p className="text-lg md:text-xl text-primary-foreground/80 mb-8 max-w-xl">
               We connect warehouse managers with quality pallet racking systems—new and used—from our vetted network of manufacturers. Submit a request and we'll contact you within 24 hours.
             </p>
 
             {/* CTAs */}
             <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <Button variant="hero" size="xl" asChild>
                  <Link to="/quote" data-track-cta="hero_get_quote">
                    Get a Free Quote
                    <ArrowRight className="h-5 w-5" />
                  </Link>
                </Button>
               <Button variant="hero-secondary" size="xl" asChild>
                 <Link to="/how-it-works">
                   <Play className="h-5 w-5" />
                   How It Works
                 </Link>
               </Button>
             </div>
 
           </motion.div>
 
           {/* Hero Image/Visual */}
           <motion.div 
             className="relative hidden lg:flex items-center justify-center"
             initial={{ opacity: 0, x: 20 }}
             animate={{ opacity: 1, x: 0 }}
             transition={{ duration: 0.6, delay: 0.2 }}
           >
             <div className="relative w-full aspect-square max-w-lg">
               {/* Decorative elements */}
               <div className="absolute inset-0 rounded-3xl bg-accent/20 transform rotate-6" />
               <div className="absolute inset-0 rounded-3xl bg-accent/10 transform -rotate-3" />
               
               {/* Main content box */}
               <div className="relative rounded-3xl bg-card p-8 shadow-elevated h-full flex flex-col justify-center">
                 <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-4">
                      <img src={logo} alt="" className="h-16 w-auto" width="96" height="64" />
                    </div>
                   <h2 className="text-xl font-bold text-foreground mb-2">Quick Quote Calculator</h2>
                   <p className="text-sm text-muted-foreground">Get an instant estimate</p>
                 </div>
 
                 <div className="space-y-4">
                   <div className="flex items-center justify-between p-4 rounded-xl bg-muted">
                     <span className="text-sm font-medium">System Type</span>
                     <span className="text-sm text-accent font-semibold">Selective Teardrop</span>
                   </div>
                   <div className="flex items-center justify-between p-4 rounded-xl bg-muted">
                     <span className="text-sm font-medium">Condition</span>
                     <span className="text-sm text-accent font-semibold">New & Used</span>
                   </div>
                   <div className="flex items-center justify-between p-4 rounded-xl bg-muted">
                     <span className="text-sm font-medium">Locations</span>
                     <span className="text-sm text-accent font-semibold">All 50 States</span>
                   </div>
                 </div>
 
                 <Button variant="accent" size="lg" className="w-full mt-6" asChild>
                   <Link to="/quote">
                     Start Your Quote
                     <ArrowRight className="h-4 w-4" />
                   </Link>
                 </Button>
               </div>
             </div>
           </motion.div>
         </div>
       </div>
     </section>
   );
 }